module.exports = __webpack_public_path__ + "img/20191025171817302.2b0c1098.jpg";